const _excluded = ["children", "renderTopNavigation", "renderAboveLayout", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@adsk/alloy-react-box';
import { SideNavigationProvider } from '@adsk/alloy-side-navigation';
import TopNavigation from '@adsk/alloy-top-navigation';

/**
 * Skeleton for top navigation frame
 */
const TopNavigationLayout = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      children,
      renderTopNavigation,
      renderAboveLayout,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SideNavigationProvider, null, /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    width: "100vw"
  }, props, {
    ref: ref,
    style: style
  }), renderAboveLayout === null || renderAboveLayout === void 0 ? void 0 : renderAboveLayout(), renderTopNavigation(), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    minHeight: 0,
    overflow: "auto"
  }, children)));
});
TopNavigationLayout.displayName = 'TopNavigationLayout';
TopNavigationLayout.defaultProps = {
  renderTopNavigation: props => /*#__PURE__*/React.createElement(TopNavigation, props)
};
TopNavigationLayout.propTypes = {
  /** Page content */
  children: PropTypes.node,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Top navigation render function */
  renderTopNavigation: PropTypes.func,
  /** Items that will render above the layout*/
  renderAboveLayout: PropTypes.func,
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
export default TopNavigationLayout;
//# sourceMappingURL=TopNavigationLayout.js.map